import {TaskEvent} from "../../api/Tasks2";
import moment from "moment";
import {Compose} from "./Compose";
import {css} from "@emotion/css";
import {Chip} from "@mui/material";
import {TagItem} from "./viewTask/TagItem";
import {Person} from "@mui/icons-material";
import {CommentView} from "./viewTask/CommentView";

export function TaskEvents(props: {
    task2: number;
    value: TaskEvent[];
    onUpdate(): void;
}) {
    return (
        <div style={{
            padding: 16,
            display: "flex",
            flexDirection: 'column',
            gap: 16,
        }}>
            <Compose
                task2={props.task2}
                onUpdate={props.onUpdate}
            />
            {props.value.map(v => (<TaskEventView value={v} />))}
        </div>
    )
}

function TaskEventView(props: {
    value: TaskEvent;
}) {
    const v = props.value;
    const header = <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 10,
    }}>
        {v.meta.usrName && <div style={{fontSize: "0.8rem", fontWeight: "600"}}>{v.meta.usrName}</div>}
        <div style={{fontSize: "0.75rem"}}>{moment(v.createdAt).format("MMM D, YYYY, hh:mm A")}</div>
    </div>;

    if(v.commentObj) {
        if(v.commentObj.archived) {
            return (
                <div>
                    {header}
                    <div style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: 8,
                        ...contentPad,
                        fontSize: "0.9rem",
                    }}>
                        <i>Comment removed</i>
                    </div>
                </div>
            );
        }
        return (
            <div>
                {header}
                <CommentView value={props.value} />
            </div>
        );
    }

    return (
        <div>
            {header}
            <div style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: 8,
                ...contentPad,
                fontSize: "0.9rem",
            }}>
                <div className={userContentCss} style={{minWidth: "auto"}}>
                    {v.description}:
                </div>
                <div style={{flex: 1, display: "flex", flexDirection: "row", alignItems: "flex-start", gap: 8}}>
                    {v.meta.tag && <TagItem color={v.meta.tagColor}>{v.meta.tagName}</TagItem>}
                    {(v.meta.oldTitle || v.meta.newTitle) && <ReplaceStr old={v.meta.oldTitle} new={v.meta.newTitle} />}
                    {(v.meta.oldColumn || v.meta.newColumn) && <ReplaceStr old={v.meta.oldColumn} new={v.meta.newColumn} />}
                    {v.meta.targetUsr && <Chip label={v.meta.targetUsrName} size="small" icon={<Person />} />}
                </div>
            </div>
        </div>
    );
}

function ReplaceStr(props: {
    old: string;
    new: string;
}) {
    return (
        <div style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 4,
        }}>
            <div style={{
                textDecoration: "line-through",
            }}>
                {props.old}
            </div>
            <div style={{}}>
                {props.new}
            </div>
        </div>
    )
}

export const contentPad = {
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 4,
    paddingBottom: 4,
}

export const userContentCss = css({
    whiteSpace: 'pre-wrap',
    wordBreak: "break-word",
    minWidth: 400,
    overflow: "hidden",
    fontSize: "0.9rem",

    "& p": {
        marginTop: 0,
        marginBottom: 0,
    },
})